import { Pipe, PipeTransform } from "@angular/core";
/**
 * 받침에 따른 조사 변경 pipe
 * consonant array 에 앞에는 받침이 있을 경우의 consonant 를, 뒤에는 받침이 없을 경우의 consonant 를 입력합니다.
 */
@Pipe({
  name: 'replacePostPosition'
})
export class ReplacePostPositionPipe implements PipeTransform {
  transform(contents: string, consonant: string[]): string {
    if (consonant.length != 2) {
      throw new Error('Consonant should contains 2 elements.');
    }
    return ReplacePostPositionPipe.isEndWithConsonant(contents) ? `${contents}${consonant[0]}` : `${contents}${consonant[1]}`;
  }

  private static isEndWithConsonant(korStr) {
    const finalChrCode = korStr.charCodeAt(korStr.length - 1)
    // 0 = 받침 없음, 그 외 = 받침 있음
    const finalConsonantCode = (finalChrCode - 44032) % 28
    return finalConsonantCode !== 0
  };
}
